const GarrisonTimelinePagination = ({hasNextPage, isFetchingNextPage, onLoadMore}) => {
  if (!hasNextPage) return null;

  return (
    <div className="flex h-10 items-center justify-end border border-t-0 border-[#E2E8F0] px-3">
      <span className="see-more" onClick={isFetchingNextPage ? undefined : onLoadMore}>
        {isFetchingNextPage ? "Carregando..." : "Ver mais"}
      </span>
    </div>
  );
};

export default GarrisonTimelinePagination;
